

// This is to get around a bug where the bundler thinks is a url or resource then crashes.

/**
 * Adds a GID to an ID.
 * @param {Object} options - Options object.
 * @param {string} options.id - The ID to add a GID to.
 * @param {'Metaobject' | 'ProductVariant' | 'Product'} options.dataType - The data type of the ID.
 * @returns {string} - The GID.
 */
export const addGid = ({ id, dataType }) => {
  if (!id || !dataType) {
    throw new Error('id and dataType are required');
  }
  if (!['Metaobject', 'ProductVariant', 'Product'].includes(dataType)) {
    throw new Error('dataType must be either Metaobject, ProductVariant or Product');
  }

  return 'gid:' + '/' + `/shopify/${dataType}/${id}`;
};

/**
 * Adds a base GID to a data type.
 * @param {Object} options - Options object.
 * @param {'Metaobject' | 'ProductVariant' | 'Product'} options.dataType - The data type of the ID.
 * @returns {string} - The base GID.
 */
export const addBaseGid = ({ dataType }) => {
  if (!dataType) {
    throw new Error('dataType is required');
  }
  return 'gid:' + '/' + `/shopify/${dataType}`;
};

/**
 * Removes a GID from an ID.
 * @param {Object} options - Options object.
 * @param {string} options.id - The ID to remove a GID from.
 * @returns {string} - The ID without the GID.
 */
export const removeGid = ({ id }) => {
  const theRegex = new RegExp('gid:' + '/' + `/shopify/(Metaobject|ProductVariant|Product)/`);
  return id.replace(theRegex, '');
};
